








import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import {
  WidgetMixin,
  FieldMixin,
  LayoutMixin,
  GroupMixin,
  Validator,
} from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue"),
  },
})
export default class WCheckboxGroup extends Mixins(
  WidgetMixin,
  FieldMixin,
  LayoutMixin,
  GroupMixin
) {
  @Prop({ type: Array, default: () => [] })
  default!: any[];

  @Validator("required")
  requiredValidator(value: any) {
    return true;
  }
}
